import { useSelector } from 'react-redux'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from './store'
import { useDispatchActions, setStoreState } from './utils'
import { storageUtil } from '@/utils'

const { setLocalStorage, getLocalStorage } = storageUtil

export interface CorpSetting {
  language: string
  currencyId: string
  currencySymbol: string
  qualityPrecision: number
  pricePrecision: number
  cloudAttrs: string[]
  cloudStoreStockType: number
  stockOn: boolean
  startQuantityOn: boolean
  minNumStep: boolean
  salesSlipOn: boolean
  cloudProductSort: number
  [key: string]: any
}

const initialState: CorpSetting = {
  language: 'zh_CN',
  currencyId: '',
  currencySymbol: '¥',
  qualityPrecision: 2, // 数量小数位数
  pricePrecision: 2, // 价格小数位
  cloudAttrs: [], // 属性显示
  cloudStoreStockType: 0, // 库存类型：0实物库存，1可售库存
  stockOn: true, // 有货才可以下单
  startQuantityOn: true, // 起订量开关
  minNumStep: true, // 货品是否增加起订量递增
  salesSlipOn: true, // 显示销售次数
  cloudProductSort: -1, // 默认显示排序：1：综合排序, 2：价格降序, 3：价格升序,4：销量降序, 5：销量升序，6：上架时间降序,7：货品名
  singleOrderMaxAmount: 100000000, // 限制单笔订单最大金额
}

export const slice = createSlice({
  name: 'corpSetting',
  initialState,
  reducers: {
    setCorpSetting: (state, action: PayloadAction<CorpSetting>) => {
      const payload = action.payload
      setStoreState(state, payload)
      setLocalStorage('corpSetting', payload)
    },
  },
})

export const { setCorpSetting: corpSettingActionCreator } = slice.actions
export const reducer = slice.reducer

export default function useCorpSettingStore() {
  const state = useSelector((state: RootState) => state.corpSetting)
  const storageState = getLocalStorage('corpSetting', true) || {}
  const actionPool = useDispatchActions(slice.actions)

  return {
    corpSetting: { ...state, ...storageState },
    ...actionPool,
  }
}
